import axiosInstance from '../../../../utils/axiosInstance';

export const getBadgeForm = async (vendorCode) => {
  const { data } = await axiosInstance.get(`/badges/${vendorCode}/`);
  return data;
};

export const createAttendee = async (vendorCode, attendeeData) => {
  const { data } = await axiosInstance.post(`/badges/${vendorCode}/attendees/`, attendeeData);
  return data;
};

export const updateAttendee = async (vendorCode, badgeId, attendeeData) => {
  const { data } = await axiosInstance.put(`/badges/${vendorCode}/attendees/${badgeId}/`, attendeeData);
  return data;
};

export const deleteAttendee = async (vendorCode, badgeId) => {
  await axiosInstance.delete(`/badges/${vendorCode}/attendees/${badgeId}/`);
};
